module.exports = __webpack_public_path__ + "img/done.897393cf.svg";